import { Download, MousePointerClick, Check } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";

const STEPS = [
  {
    n: "01",
    icon: Download,
    color: "text-nora-accent",
    title: "Скачайте",
    text: "Из App Store, Google Play или для Windows",
  },
  {
    n: "02",
    icon: MousePointerClick,
    color: "text-nora-pink",
    title: "Нажмите",
    text: "Одна большая кнопка. Кротик сделает остальное",
  },
  {
    n: "03",
    icon: Check,
    color: "text-nora-mint",
    title: "Готово",
    text: "Вы в НОРЕ. Можно жить и развиваться дальше без ограничений.",
  },
];

export default function Steps() {
  return (
    <section id="how" className="py-16 sm:py-24">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <Chapter n="02">Как это работает</Chapter>
        <Reveal delay={0.1}>
          <h2 className="mt-4 font-display text-3xl font-bold tracking-tight md:text-4xl">
            Скачайте. Нажмите. Готово.
          </h2>
        </Reveal>
        <div className="mt-10 grid gap-5 md:grid-cols-3">
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.n} delay={0.15 + i * 0.12}>
                <div
                  data-testid={`step-card-${i + 1}`}
                  className="relative h-full overflow-hidden rounded-[2rem] border border-nora-ink/5 bg-nora-surface p-8 shadow-sm transition-transform duration-300 hover:-translate-y-2"
                >
                  <span
                    aria-hidden="true"
                    className={`pointer-events-none absolute -right-2 -top-6 font-display text-8xl font-black opacity-10 ${s.color}`}
                  >
                    {s.n}
                  </span>
                  <Icon className={`h-8 w-8 ${s.color}`} />
                  <h3 className="mt-5 font-display text-xl font-bold md:text-2xl">
                    {s.title}
                  </h3>
                  <p className="mt-2 leading-relaxed text-nora-ink/70">
                    {s.text}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
